// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LiquidVolume } from "../automated-pro/RnaCatalog";
import { defaultAmpState } from "../rna-fish/EditKitForm";
import { ampKitToAmpFormState, findVolumeOrDefault } from "../rna-fish/RnaFishKitToFormState";
import { defaultBuffersState as defaultSecondaryIfBuffersState, defaultProbeState } from "./NewSecondaryIfKitPage";
import { getSecondaryIfAmplifierCatalog, getSecondaryIfProbeCatalog } from "./SecondaryIfCatalog";
export var secondaryIfKitToFormState = function (catalog, kit, admin, kitPrice) {
    var _a;
    var probeCatalog = getSecondaryIfProbeCatalog(kit.legacy, catalog);
    var amplifierCatalog = getSecondaryIfAmplifierCatalog(kit.legacy, catalog);
    var probeEnabled = false;
    var probeState = defaultProbeState(getSecondaryIfProbeCatalog(kit.legacy, catalog));
    var probeComponentAmplifier;
    var probeComponent = kit.probeComponent;
    if (probeComponent !== undefined) {
        probeEnabled = true;
        var probe = probeCatalog.probes.find(function (p) { return p.id === probeComponent.probe.id; });
        if (probe !== undefined) {
            var probeAmplifier = probe.amplifiers.find(function (a) { return a.id === probeComponent.amplifier.id; });
            if (probeAmplifier !== undefined) {
                probeState = __assign(__assign({}, probeState), { probeAmplifier: probeAmplifier });
                probeComponentAmplifier = probeAmplifier.amplifier;
            }
        }
        var scale = probeCatalog.scales.find(function (s) { return s.ugram === probeComponent.scale.ugram; });
        if (scale !== undefined) {
            probeState = __assign(__assign({}, probeState), { scale: scale });
        }
        if (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.probePriceCustom) {
            probeState = __assign(__assign({}, probeState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.probePriceCents
                } });
        }
    }
    var ampEnabled = false;
    var ampState = defaultAmpState(amplifierCatalog);
    // preload probe's amplifier, if present
    if (probeComponentAmplifier !== undefined) {
        ampState = __assign(__assign({}, ampState), { hcrAmplifier: probeComponentAmplifier });
    }
    if (kit.amplifierComponent !== undefined) {
        ampEnabled = true;
        ampState = ampKitToAmpFormState(ampState, kit.amplifierComponent, amplifierCatalog, admin);
        if ((kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.amplifierPriceCustom) === true) {
            ampState = __assign(__assign({}, ampState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.amplifierPriceCents
                } });
        }
    }
    var buffersEnabled = false;
    var buffersState = defaultSecondaryIfBuffersState(catalog, kit.legacy);
    var buffersComponent = kit.buffersComponent;
    if (buffersComponent !== undefined) {
        buffersEnabled = true;
        if ((kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.buffersPriceCustom) === true) {
            buffersState = __assign(__assign({}, buffersState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: kitPrice.buffersPriceCents
                } });
        }
        buffersState = __assign(__assign({}, buffersState), { antibody: findVolumeOrDefault(catalog.buffer.antibody, buffersComponent.antibodyBuffer), antibodyWash: !kit.legacy ? findVolumeOrDefault(catalog.buffer.antibodyWash, buffersComponent.antibodyWashBuffer) : new LiquidVolume(0), amplification: findVolumeOrDefault(catalog.buffer.amplification, buffersComponent.amplificationBuffer), goldAmpWash: !kit.legacy ? findVolumeOrDefault(catalog.buffer.goldAmpWash, buffersComponent.goldAmpWashBuffer) : new LiquidVolume(0) });
    }
    var sampleTypeFormState = {
        sampleType: (_a = catalog.buffer.sampleTypes.find(function (t) { return t.id === kit.sampleType.id; })) !== null && _a !== void 0 ? _a : catalog.buffer.defaultSampleType
    };
    return {
        probeEnabled: probeEnabled,
        probeState: probeState,
        ampEnabled: ampEnabled,
        ampState: ampState,
        buffersEnabled: buffersEnabled,
        buffersState: buffersState,
        sampleTypeFormState: sampleTypeFormState,
        legacy: kit.legacy,
        comment: kit.comment,
        price: undefined,
        priceLoading: false,
        errors: []
    };
};
//# sourceMappingURL=SecondaryIfKitToFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/secondary-if/SecondaryIfKitToFormState.js
// module id = 329
// module chunks = 0